/* Giorgio header: mega menu + phone drawer. Loaded by sections/giorgio-header.liquid */
/* A flavour link in the menu (?variant=...) is a choice the shopper made.
   giorgio-nodefault-variant.js only counts ?variant= as chosen when the link
   came from ANOTHER page, so a menu click made while already on that product
   opened on "Choose your ... flavor". The click is noted here, and on the
   next page -- before that script runs (both deferred, the header first) --
   it is written as the product's own "picked" flag. "Create Your Own" is left
   alone: it opens straight on the flavour dropdown, as the client wants. */
(function () {
  try {
    var KEY = 'gioNavPick';
    var cfg = window.ggNoDefault;
    if (sessionStorage.getItem(KEY) === '1') {
      sessionStorage.removeItem(KEY);
      if (/[?&]variant=/.test(window.location.search) && cfg && cfg.productId) {
        sessionStorage.setItem('ggPicked:' + cfg.productId, '1');
      }
    }
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('[data-gh] a[href*="variant="], [data-gh-drawer] a[href*="variant="]');
      if (a && !/create your own/i.test(a.textContent)) { try { sessionStorage.setItem(KEY, '1'); } catch (x) {} }
    }, true);
  } catch (e) {}
})();
/* Product tags: shrink the type a quarter-pixel at a time until the row fits on one line. */
(function () {
  function fit() {
    var rows = document.querySelectorAll('.prod-tags');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i], size = 12;
      row.style.setProperty('--gio-tag-fs', size + 'px');
      while (row.scrollWidth > row.clientWidth + 1 && size > 8) {
        size -= 0.25;
        row.style.setProperty('--gio-tag-fs', size + 'px');
      }
    }
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(fit, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', soon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();
/* Dropdown tags on the 2nd option (gift boxes: coffee / cookie flavor).
   The variant picker only prints tags for option 1. For the others, start a line
   in "Subtitle 2" with the tag and two colons -- "Seasonal::Cinnamon, nutmeg + cloves"
   or "Best Seller,Seasonal::..." -- and it is shown as the same pink tag as option 1,
   with the colons and tag removed from the description. Re-runs when the theme
   re-renders the picker after a variant change. */
(function () {
  function run() {
    var subs = document.querySelectorAll('.fd-option .fd-option-sub');
    for (var i = 0; i < subs.length; i++) {
      var s = subs[i], txt = s.textContent, k = txt.indexOf('::');
      if (k < 0) continue;
      var tags = txt.slice(0, k).split(',');
      s.textContent = txt.slice(k + 2).trim();
      var opt = s.closest('.fd-option');
      var name = opt && opt.querySelector('.fd-option-name');
      if (!name) continue;
      for (var j = 0; j < tags.length; j++) {
        var tag = tags[j].trim();
        if (!tag) continue;
        var b = document.createElement('span');
        b.className = 'fd-group-tagg fd-name-badge';
        b.textContent = tag;
        name.appendChild(b);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var q;
  if (window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(q); q = setTimeout(run, 30); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
/* Gourmet Gifts page: open a tab from the link. /collections/gourmet-gifts?tab=biscotti
   (or #biscotti) opens the tab whose label is "Biscotti" and scrolls to the products.
   The key is the tab label in lowercase with spaces and symbols as dashes:
   gift-jars, gift-boxes, gift-sets, biscotti, cookies, coffee-tea, seasonal, birthday.
   Clicking a tab also writes ?tab= into the address bar, so the page can be shared
   or bookmarked on that tab. */
(function () {
  function key(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function tabs() { return document.querySelectorAll('.gg-tab[data-gg-tab]'); }
  function open() {
    var want = '';
    try { want = new URLSearchParams(window.location.search).get('tab') || ''; } catch (e) {}
    if (!want) want = window.location.hash.replace('#', '');
    want = key(want);
    if (!want) return;
    var list = tabs();
    for (var i = 0; i < list.length; i++) {
      if (key(list[i].textContent) === want) {
        list[i].click();
        var bar = list[i].closest('.gg-tabbar');
        if (bar) setTimeout(function () { window.scrollTo({ top: bar.getBoundingClientRect().top + window.scrollY }); }, 60);
        return;
      }
    }
  }
  function remember() {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('.gg-tab[data-gg-tab]');
      if (!t || !window.history || !history.replaceState) return;
      try {
        var u = new URL(window.location.href);
        if (t.getAttribute('data-gg-tab') === 'all') u.searchParams.delete('tab'); else u.searchParams.set('tab', key(t.textContent));
        u.hash = '';
        history.replaceState(null, '', u.toString());
      } catch (x) {}
    });
  }
  function init() { if (!tabs().length) return; open(); remember(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
(function () {
  var root = document.querySelector('[data-gh]');
  var drawer = document.querySelector('[data-gh-drawer]');
  if (!root || root.__gh) return;
  root.__gh = true;
  /* ---- desktop mega menu ---- */
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  var items = [].slice.call(root.querySelectorAll('.gh-item'));
  var timer;
  var isHome = root.classList.contains('gh--overlay');
  function setSolid() {
    if (!isHome) return;
    var on = root.matches(':hover') || !!root.querySelector('.gh-item.is-open') || root.contains(document.activeElement) || !!root.querySelector('details[open]');
    root.classList.toggle('is-solid', on);
  }
  function closeAll() {
    items.forEach(function (li) {
      li.classList.remove('is-open');
      var a = li.querySelector('.gh-link');
      if (a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false');
    });
    setSolid();
  }
  function openItem(li) {
    items.forEach(function (x) { if (x !== li) { x.classList.remove('is-open'); var a = x.querySelector('.gh-link'); if (a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false'); } });
    if (li.querySelector('.gh-mega')) {
      li.classList.add('is-open');
      li.querySelector('.gh-link').setAttribute('aria-expanded', 'true');
    }
    setSolid();
  }
  items.forEach(function (li) {
    var a = li.querySelector('.gh-link');
    li.addEventListener('mouseenter', function () { if (!hoverable.matches) return; clearTimeout(timer); timer = setTimeout(function () { openItem(li); }, 90); });
    li.addEventListener('mouseleave', function () { if (!hoverable.matches) return; clearTimeout(timer); timer = setTimeout(closeAll, 160); });
    a.addEventListener('click', function (e) {
      if (!li.querySelector('.gh-mega')) return;
      /* touch screens: first tap opens the panel, second tap follows the link */
      if (!hoverable.matches && !li.classList.contains('is-open')) { e.preventDefault(); openItem(li); }
    });
    a.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') && li.querySelector('.gh-mega') && !li.classList.contains('is-open')) { e.preventDefault(); openItem(li); }
    });
  });
  root.addEventListener('focusout', function () { setTimeout(function () { if (!root.contains(document.activeElement)) closeAll(); }, 0); });
  root.addEventListener('mouseenter', setSolid);
  root.addEventListener('mouseleave', function () { setTimeout(setSolid, 180); });
  root.addEventListener('toggle', setSolid, true);
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });
  /* the word "Search" opens the same search panel as the icon */
  var label = root.querySelector('.gh-search-label');
  if (label) label.addEventListener('click', function () { var s = root.querySelector('.gh-search summary'); if (s) s.click(); });
  /* ---- small-screen drawer ---- */
  var opener = root.querySelector('[data-gh-open]');
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    opener.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('gh-lock');
    var c = drawer.querySelector('.gh-close'); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    opener.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('gh-lock');
    opener.focus();
  }
  opener.addEventListener('click', openDrawer);
  [].forEach.call(drawer.querySelectorAll('[data-gh-close]'), function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });
  /* the bag icon opens the cart drawer when the theme has one */
  var bag = drawer.querySelector('[data-gh-bag]');
  if (bag) bag.addEventListener('click', function (e) {
    if (!document.querySelector('cart-drawer')) return;
    e.preventDefault(); closeDrawer();
    var icon = document.getElementById('cart-icon-bubble'); if (icon) icon.click();
  });
  [].forEach.call(drawer.querySelectorAll('[data-gh-tab]'), function (tab) {
    tab.addEventListener('click', function () {
      [].forEach.call(drawer.querySelectorAll('[data-gh-tab]'), function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      [].forEach.call(drawer.querySelectorAll('[data-gh-pane]'), function (p) { p.hidden = p.getAttribute('data-gh-pane') !== tab.getAttribute('data-gh-tab'); });
    });
  });
  /* + / − rows: one open at a time within each list */
  [].forEach.call(drawer.querySelectorAll('.gh-m-item > button.gh-m-top'), function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentNode;
      var list = item.parentNode;
      var willOpen = !item.classList.contains('is-open');
      [].forEach.call(list.children, function (x) {
        if (x.classList && x.classList.contains('is-open')) { x.classList.remove('is-open'); var b = x.querySelector('.gh-m-top'); if (b) b.setAttribute('aria-expanded', 'false'); }
      });
      if (willOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });
  window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) closeDrawer(); });
})();